/*
* PL・BS計算
*/
export default class calculateFinancialStatement {
  constructor() {
    this.$tabButtons = [].slice.call(document.querySelectorAll('[data-target="tabButton"]'));
    this.$tabContents = [].slice.call(document.querySelectorAll('[data-target="tabContent"]'));
    this.$sumFields = [].slice.call(document.querySelectorAll('[data-field="financialStatementSum"]'));
    this.$form = document.getElementById('financialStatementForm');
  }

  attachEvent() {
    // PL・BSタブの切り替え
    Array.prototype.forEach.call(this.$tabButtons, button => {
      button.addEventListener('click', () => {
        const tabName = button.getAttribute('data-tab-name');
        const tabContent = this.$tabContents.find(content => content.dataset.tab == tabName);
        const activeBtn = this.$tabButtons.find(btn => btn.classList.contains('active'));
        const activeContent = this.$tabContents.find(content => content.classList.contains('active'));

        activeBtn.classList.remove('active');
        activeContent.classList.remove('active');
        button.classList.add('active');
        tabContent.classList.add('active');
      });
    });

    // 合計値計算
    const categories = this.$sumFields.map(field => field.id);

    calculate();
    this.$form.addEventListener('change', () => { calculate(); });
    this.$form.addEventListener('click', () => { calculate(); });

    function calculate() {
      // 入力項目→小計→総計と段階を踏んで計算されるため処理を２回繰り返し
      setTimeout(() => {
        Array(2).fill().forEach(() => {
          categories.forEach(category => {
            const target = document.querySelector(`#${category}`);
            const fields = [].slice.call(document.querySelectorAll(`[data-target="${category}"]`));
            const values = fields.map(field => {
              const cleanValue = field.value.replace('¥', '').replace(/,/g, '');
              return cleanValue ? Number(cleanValue) : 0;
            });

            if (values.length) {
              const sum = values.reduce((acc, val) => acc + val);
              target.value = `¥${sum.toLocaleString()}`;
            }
          });
        });
      }, 100);
    }
  }
}
